module.exports = __webpack_public_path__ + "img/gradiant.8b206978.svg";